import { useContext } from '@nuxtjs/composition-api';

export function useRoute() {
  const { route } = useContext();

  return route;
}
